import React, {Fragment} from 'react';
import {Banner} from './Banner/Banner';
import {BannerModal} from './Modal/Modal';
import {cookieExists, GLOBAL_BANNER_COOKIE_PREFIX} from './utils/cookies';

function AppBanner({displayType, globalMessageId, ...props}) {
    const globalMessageCookie = `${GLOBAL_BANNER_COOKIE_PREFIX}-${globalMessageId}`;
    if (!globalMessageId || (globalMessageId && cookieExists(globalMessageCookie))) {
        return (<Fragment>
            {(displayType && displayType === 'modal') ? <BannerModal {...props} /> : <Banner {...props} />}</Fragment>
        );
    }
    return (<Fragment></Fragment>);
}

export default AppBanner;
